import { timeoutProvider } from '../scheduler/timeoutProvider.js';

function reportUnhandledError(err) {
    timeoutProvider.setTimeout(function () {
        {
            throw err;
        }
    });
}

export { reportUnhandledError };
//# sourceMappingURL=reportUnhandledError.js.map
